import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";
import { Row, Col, Form, InputGroup } from "react-bootstrap";

import { formatDate } from "../../../../utils/date-utils/date-utils";

export const DateSelect = ({
  date,
  isValid,
  isInvalid,
  disabled,
  handleDateSelect,
}) => {
  const intl = useIntl();

  const date1DateInputRef = useRef(null);
  const date1TimeInputRef = useRef(null);
  const date2DateInputRef = useRef(null);
  const date2TimeInputRef = useRef(null);
  const [type, setType] = useState(null);

  useEffect(() => {
    setType(date.type);
  }, [date]);

  return (
    <div>
      <div className="mb-3">
        <Form.Check
          inline
          label={intl.formatMessage({
            id: "data.serviceworksheet.form.date.value.FULL_DAY",
          })}
          value="FULL_DAY"
          name="service-worksheet-date"
          type="radio"
          id="service-worksheet-date-fullday"
          disabled={disabled}
          checked={type === "FULL_DAY"}
          onChange={() => {
            handleDateSelect({
              ...date,
              type: "FULL_DAY",
            });
          }}
        />
        <Form.Check
          inline
          label={intl.formatMessage({
            id: "data.serviceworksheet.form.date.value.PERIOD",
          })}
          value="PERIOD"
          name="service-worksheet-date"
          type="radio"
          id="service-worksheet-date-period"
          disabled={disabled}
          checked={type === "PERIOD"}
          onChange={() => {
            handleDateSelect({
              ...date,
              type: "PERIOD",
            });
          }}
        />
      </div>
      <Row className="mb-3">
        <Col lg="5">
          <InputGroup>
            <Form.Control
              type="date"
              value={
                date?.date1Time
                  ? formatDate(new Date(date?.date1Time), "YYYY-MM-DD")
                  : ""
              }
              ref={date1DateInputRef}
              isValid={isValid}
              isInvalid={isInvalid}
              disabled={disabled}
              onChange={(event) => {
                handleDateSelect({
                  ...date,
                  date1Time: new Date(
                    `${event.target.value} ${date1TimeInputRef.current.value}`,
                  ).getTime(),
                });
              }}
            />
            <Form.Control
              className={type === "FULL_DAY" ? "invisible" : null}
              type="time"
              defaultValue={
                date?.date1Time
                  ? formatDate(new Date(date?.date1Time), "hh:mm:ss")
                  : ""
              }
              ref={date1TimeInputRef}
              isValid={isValid}
              isInvalid={isInvalid}
              disabled={disabled}
              onChange={(event) => {
                handleDateSelect({
                  ...date,
                  date1Time: new Date(
                    `${date1DateInputRef.current.value} ${event.target.value}`,
                  ).getTime(),
                });
              }}
            />
          </InputGroup>
        </Col>
        <Col lg="2" className={type === "FULL_DAY" ? "invisible" : null}>
          <div className="text-center"> - </div>
        </Col>
        <Col lg="5" className={type === "FULL_DAY" ? "invisible" : null}>
          <InputGroup>
            <Form.Control
              type="date"
              value={
                date?.date2Time
                  ? formatDate(new Date(date?.date2Time), "YYYY-MM-DD")
                  : ""
              }
              ref={date2DateInputRef}
              isValid={isValid}
              isInvalid={isInvalid}
              disabled={disabled}
              onChange={(event) => {
                handleDateSelect({
                  ...date,
                  date2Time: new Date(
                    `${event.target.value} ${date2TimeInputRef.current.value}`,
                  ).getTime(),
                });
              }}
            />
            <Form.Control
              type="time"
              defaultValue={
                date?.date2Time
                  ? formatDate(new Date(date?.date2Time), "hh:mm:ss")
                  : ""
              }
              ref={date2TimeInputRef}
              isValid={isValid}
              isInvalid={isInvalid}
              disabled={disabled}
              onChange={(event) => {
                handleDateSelect({
                  ...date,
                  date2Time: new Date(
                    `${date2DateInputRef.current.value} ${event.target.value}`,
                  ).getTime(),
                });
              }}
            />
          </InputGroup>
        </Col>
      </Row>
    </div>
  );
};

DateSelect.propTypes = {
  date: PropTypes.object,
  isValid: PropTypes.bool.isRequired,
  isInvalid: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  handleDateSelect: PropTypes.func.isRequired,
};
